import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormContentBlockerFieldGeneralDescription } from "./description.js";
import { FormContentBlockerFieldGeneralName } from "./name.js";
import { FormContentBlockerFieldGeneralStatus } from "./status.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { LearnMoreTag } from "../../../../common/learnMoreTag.js";
import { FormHeadline } from "../../../headline.js";
import { FormContentBlockerLayout } from "../../../layout.js";
const FormContentBlockerFieldGeneralCompose = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(FormHeadline, {
                offset: FormContentBlockerLayout.labelCol.span,
                children: [
                    __("General content blocker configuration"),
                    " ",
                    /*#__PURE__*/ _jsx(LearnMoreTag, {
                        url: __("https://devowl.io/knowledge-base/real-cookie-banner-create-individual-content-blocker/")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldGeneralName, {}),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldGeneralStatus, {}),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldGeneralDescription, {})
        ]
    });
};
export { FormContentBlockerFieldGeneralCompose };
